import auth from "../../middlewares/auth";
export const bannerRoutes = [
    {
        path: '/banner/main-sliders',
        component: () => import(/* webpackChunkName: "banners" */ '../../views/banner/MainSlider'),
        name: 'banner_main_sliders',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/banner/:type',
        component: () => import(/* webpackChunkName: "banners" */ '../../views/banner/Index'),
        name: 'banner_list',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
